import io from 'socket.io-client'
import { mainUrl } from '../config/urls'
import { isDev } from '../utils'

export default {
  install (Vue, options) {
    const mainSocket = io(mainUrl, {
      autoConnect: false,
      transports: isDev ? ['polling'] : undefined,
      path: '/ws/'
    })

    Vue.prototype.$socket = mainSocket
    Vue.$socket = mainSocket
  }
}
